import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomFieldDataTypes } from '@aksia/enums';
import { TOASTER_SERVICE_TOKEN, UTILS } from '@aksia/infrastructure';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsService {
  private customFieldsUrl;
  private readonly toasterService = inject(TOASTER_SERVICE_TOKEN);

  constructor() {
    this.customFieldsUrl = 'CustomFields';
  }
  private api = inject(CedricApiService);

  getCustomFieldsAdminViewModel(): Observable<any> {
    const url = this.customFieldsUrl + 'GetCustomFieldsAdminViewModel';
    return this.api.post(url);
  }

  getCustomFieldsDefinition(
    customFieldDefinitionId: number,
    entityId: number,
    entityTypeId: number,
  ): Observable<any> {
    const url = this.customFieldsUrl + '/GetCustomFieldDefinition';
    return this.api.post(url, {
      customFieldDefinitionId,
      entityId,
      entityTypeId,
    });
  }

  getCustomFieldsDefinitionById(id: number): Observable<any> {
    const url = this.customFieldsUrl + '/GetCustomFieldsDefinitionById';
    return this.api.post(url, { id });
  }

  getWhereCustomFieldListIsUsed(id: number): Observable<any> {
    const url = this.customFieldsUrl + 'GetWhereCustomFieldListIsUsed';
    return this.api.post(url, { id });
  }

  getWhereCustomFieldDefinitionIsUsed(id: number): Observable<any> {
    const url = this.customFieldsUrl + 'GetWhereCustomFieldDefinitionIsUsed';
    return this.api.post(url, { id });
  }

  deleteCustomFieldDefinition(id: number): Observable<any> {
    const url = this.customFieldsUrl + 'DeleteCustomFieldDefinition';
    return this.api.post(url, { id });
  }

  //   addOrUpdateCustomFieldDefinition(
  //     customFieldDefinition: CustomFieldDefinition,
  //   ): Observable<any> {
  //     const url =
  //       this.customFieldsUrl +
  //       (customFieldDefinition.customFieldDefinitionId > 0
  //         ? '/UpdateCustomFieldDefinition'
  //         : '/AddCustomFieldDefinition');
  //     return this.api.post(url, customFieldDefinition);
  //   }
  //   updateCustomFieldList(customFieldsList: CustomFieldsList): Observable<any> {
  //     const url = this.customFieldsUrl + '/UpdateCustomFieldList';
  //     return this.api.post(url, customFieldsList);
  //   }

  deleteCustomFieldList(id: number): Observable<any> {
    const url = this.customFieldsUrl + '/DeleteCustomFieldList';
    return this.api.post(url, { id });
  }

  saveCustomFieldDataValue(
    dataDefinitionId: number,
    entityId: number,
    entityTypeId: number,
    value: string,
    applicationId: string,
  ): Observable<any> {
    const url = this.customFieldsUrl + '/SaveCustomFieldDataValue';
    return this.api.post(url, {
      dataDefinitionId,
      entityId,
      entityTypeId,
      value,
      applicationId,
    });
  }

  saveCustomFieldDataValueById(customFieldDataValue: any): Observable<any> {
    const url = this.customFieldsUrl + '/SaveCustomFieldDataValueById';
    return this.api.post(url, { customFieldDataValue });
  }

  isValidCustomDataValue(
    newValue: any,
    currentValue: any,
    dataDefinition: any,
  ) {
    if (dataDefinition.customFieldDataTypeId === 2) {
      const min = dataDefinition.min;
      const max = dataDefinition.max;
      if (min && min <= newValue && max && newValue <= max) {
        return true;
      } else if (min && newValue < min) {
        this.toasterService?.info(`Minimum value is ${dataDefinition.min}`);
        return false;
      } else if (max && newValue > max) {
        this.toasterService?.info(`Maximum value is ${dataDefinition.max}`);
        return false;
      }
    }
    return true;
  }

  parseValue(value: Date | null, dataDefinition: any) {
    if (dataDefinition?.customFieldDataTypeId == CustomFieldDataTypes.Date)
      return value ? UTILS.DATE.toLocalDateString(new Date(value)) : '';

    return value;
  }
}
